export function buildUseAndCareHref(
	sku: string,
	productName: string,
	base = "/shop/useandcare"
): string {
	return `${base}/${formEncodeSegment(productName)}/${encodeURIComponent(sku)}`;
}

function formEncodeSegment(value: string): string {
	return encodeURIComponent(value).replace(/%20/g, "+");
}
